import * as React from 'react';

import { isCourserian } from 'js/lib/user';

import {
  RECOMMENDATIONS_EXPLAINER_CHANGE_EVENT,
  isRecommendationsExplainerEnabled,
} from './recommendationsExplainerFlag';

const subscribers = new Set<() => void>();
let listening = false;

const notifySubscribers = () => subscribers.forEach((subscriber) => subscriber());

const subscribe = (subscriber: () => void) => {
  if (!isCourserian() || typeof window === 'undefined') {
    return () => {};
  }

  subscribers.add(subscriber);
  if (!listening) {
    window.addEventListener(RECOMMENDATIONS_EXPLAINER_CHANGE_EVENT, notifySubscribers);
    listening = true;
  }

  return () => {
    subscribers.delete(subscriber);
    if (subscribers.size === 0 && listening && typeof window !== 'undefined') {
      window.removeEventListener(RECOMMENDATIONS_EXPLAINER_CHANGE_EVENT, notifySubscribers);
      listening = false;
    }
  };
};

const getCourserianSnapshot = () => isRecommendationsExplainerEnabled();
const getFalseSnapshot = () => false;
const subscribeToNothing = () => () => {};

export function useRecommendationsExplainerEnabled(): boolean {
  const isCourserianUser = isCourserian();
  return React.useSyncExternalStore(
    isCourserianUser ? subscribe : subscribeToNothing,
    isCourserianUser ? getCourserianSnapshot : getFalseSnapshot,
    getFalseSnapshot
  );
}
